'use client';

import { useModal } from '~/components/Modal';

import NewJobButton from './ScanSettings/NewJobButton';
import { ScannerAssociation, SocialMediaType } from '@prisma/client';
import { useMemo } from 'react';
import { type RouterInputs } from '~/utils/api';

type UpdateScannerJobInput = RouterInputs['scanner']['updateScannerJob'];

export const initNewScanJob = ({
  isInfluencer,
  brandId,
  socialMediaType,
}: {
  isInfluencer?: boolean;
  brandId?: string;
  socialMediaType?: SocialMediaType | 'WEBSITE';
}): Partial<UpdateScannerJobInput> => ({
  name: '',
  urls: [],
  maxDepth: 0,
  maxPages: 10,
  maxTrackedPages: 100,
  newPagesForSuccessiveScans: 0,
  brandId,
  useSitemaps: false,
  association: isInfluencer ? ScannerAssociation.SPONSORED : ScannerAssociation.OWN,
  ...(isInfluencer || (socialMediaType && socialMediaType !== 'WEBSITE')
    ? {
        socialMedia: {
          type: (socialMediaType as SocialMediaType) || SocialMediaType.INSTAGRAM,
        },
      }
    : {}),
});

type NewJobProps = {
  isInfluencer: boolean;
};

export default function NewJob(props: NewJobProps) {
  const {
    openModal: newJobOpenModal,
    modalRef: newJobModalRef,
    closeModal: newJobCloseModal,
    isOpen: isJobModalOpen,
  } = useModal();

  const initialInput = useMemo(
    () => initNewScanJob({ isInfluencer: props.isInfluencer }),
    [props.isInfluencer],
  );

  return (
    <NewJobButton
      initialInput={initialInput}
      modalProperties={{
        openModal: newJobOpenModal,
        modalRef: newJobModalRef,
        closeModal: newJobCloseModal,
        isOpen: isJobModalOpen,
      }}
      isInfluencer={props.isInfluencer}
    />
  );
}
